module.exports = __webpack_public_path__ + "resources/img/img_hacking_testing2_jp.a193693a7865306742aa86c2f99363b7.png";